import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './assets/font/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/element-vars.scss'
import './assets/css/index.scss'

import { hasRight, operationsFilter } from '@/api/permission'

import { message } from '@/api/resetMessage'

import ElementUI from 'element-ui'
import echarts from '@/api/echart'

import Bus from '@/api/bus'
import resetSetItem from '@/api/reset_set_item'
import caseHelper from '@/api/case_helper'

Vue.prototype.$tableHeight = caseHelper.setTableHeight(1)
Vue.prototype.$setTableHeight = caseHelper.setTableHeight
Vue.prototype.$operationsFilter = operationsFilter

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'small' })

Vue.prototype.$echarts = echarts
Vue.prototype.$message = message
Vue.prototype.Bus = Bus
Vue.prototype.$resetSetItem = resetSetItem

Vue.prototype.$pageSizes = [10, 20, 50, 100]

Vue.filter('myFormetter', function (value, ...params) {
  switch (params[0]) {
    case 'time':
      if (value === undefined) return '-'
      else if (value === '') return '-'
      else if (value === '1970-01-01 00:00:00') return '-'
      else return value.substr(0, value.length - 3)
    case 'list':
      if (value === undefined) return ''
      else if (value === '') return ''
      else return value.join(',')
    default:
      return value
  }
})

Vue.filter('diagnosisTime', function (value) {
  if (value === undefined) return '-'
  else if (value === '') return '-'
  else if (value === '1970-01-01 00:00:00') return '-'
  else return value.substr(0, value.length - 3)
})

Vue.directive('permission', {
  inserted (el, binding) {
    if (!hasRight(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})

new Vue({
  router,
  components: { App },
  store,
  render: h => h(App)
}).$mount('#app')
